import i18next from "i18next";

import { clientLocale } from "@/shared/localization/language";

import { TastierGlobal } from "@/portal/globalAccess";

export function i18n(key: string, param: any = {}): string {
    // Ensure param is an object and check if it has the 'lng' property
    const options = { ...param };
    // eslint-disable-next-line no-prototype-builtins
    if (!options.hasOwnProperty("lng")) {
        options.lng = TastierGlobal.getUserLocale() ?? clientLocale();
    }
    return i18next.t(key, options) as string;
}

export function isInRole(role: string): boolean {
    const identity = TastierGlobal.getIdentity();

    if (identity && identity.roles.includes(role)) {
        return true;
    }

    return false;
}
